'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSubscribers = undefined;

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _handlers = require('./handlers');

var _handlers2 = _interopRequireDefault(_handlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSubscribers = exports.initSubscribers = function initSubscribers() {
  PubSub.subscribe(_Constants2.default.showOverlay, function (message, data) {
    return _handlers2.default.show(data);
  });

  PubSub.subscribe(_Constants2.default.hideOverlay, function (message, data) {
    return _handlers2.default.hide(data);
  });

  PubSub.subscribe(_Constants2.default.toggleOverlay, function (message, data) {
    return _handlers2.default.toggle(data);
  });
};